// extracted by mini-css-extract-plugin
export var messageSideLeft = "_md-1";
export var stateContainer = "_md-0";